import BusinessIcon from '@mui/icons-material/Business'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import DashboardIcon from '@mui/icons-material/Dashboard'
import GroupsIcon from '@mui/icons-material/Groups'
import NotificationsIcon from '@mui/icons-material/Notifications'
import SecurityIcon from '@mui/icons-material/Security'
import TuneIcon from '@mui/icons-material/Tune'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilValue } from 'recoil'

import { isPricingEnabled } from '../config/environment'
import { sessionState } from '../state'

import routes from './routes'

const Landing = () => {
  const navigate = useNavigate()
  const session = useRecoilValue(sessionState)

  useEffect(() => {
    if (session.user) {
      navigate(routes.home)
    }
  }, [session.user, navigate])

  return (
    <div
      style={{
        minHeight: '100vh',
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        overflowX: 'hidden'
      }}
    >
      {/* ===== HERO SECTION ===== */}
      <section
        style={{
          minHeight: '100vh',
          background:
            'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 50%, #0ea5e9 100%)',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative'
        }}
      >
        {/* Navigation */}
        <nav
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '24px 32px',
            maxWidth: '1280px',
            width: '100%',
            margin: '0 auto',
            boxSizing: 'border-box'
          }}
        >
          <div
            style={{
              fontSize: '1.5rem',
              fontWeight: 800,
              color: '#ffffff',
              letterSpacing: '-0.5px'
            }}
          >
            Meet for Work
          </div>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
            <button
              onClick={() => navigate(routes.signin)}
              style={{
                backgroundColor: 'transparent',
                color: '#ffffff',
                border: '2px solid rgba(255, 255, 255, 0.6)',
                padding: '10px 24px',
                fontSize: '0.95rem',
                fontWeight: 600,
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                fontFamily: 'inherit'
              }}
              onMouseOver={e => {
                e.currentTarget.style.backgroundColor =
                  'rgba(255, 255, 255, 0.15)'
                e.currentTarget.style.borderColor = '#ffffff'
              }}
              onMouseOut={e => {
                e.currentTarget.style.backgroundColor = 'transparent'
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.6)'
              }}
            >
              Login
            </button>
            <button
              onClick={() => navigate(routes.signup)}
              style={{
                backgroundColor: '#ffffff',
                color: '#1e3a8a',
                border: 'none',
                padding: '10px 24px',
                fontSize: '0.95rem',
                fontWeight: 600,
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                fontFamily: 'inherit'
              }}
              onMouseOver={e => {
                e.currentTarget.style.transform = 'translateY(-1px)'
                e.currentTarget.style.boxShadow =
                  '0 4px 12px rgba(0, 0, 0, 0.2)'
              }}
              onMouseOut={e => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = 'none'
              }}
            >
              Sign Up Free
            </button>
          </div>
        </nav>

        {/* Hero Content */}
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '64px 24px',
            textAlign: 'center',
            maxWidth: '900px',
            margin: '0 auto'
          }}
        >
          <h1
            style={{
              fontSize: 'clamp(2.5rem, 5vw, 4rem)',
              fontWeight: 800,
              color: '#ffffff',
              marginBottom: '24px',
              lineHeight: 1.15,
              letterSpacing: '-1px'
            }}
          >
            The Smartest Way to Manage Your Hybrid Office
          </h1>
          <p
            style={{
              fontSize: 'clamp(1.1rem, 2vw, 1.4rem)',
              color: 'rgba(255, 255, 255, 0.92)',
              marginBottom: '48px',
              lineHeight: 1.7,
              fontWeight: 400,
              maxWidth: '700px'
            }}
          >
            Meet for Work helps teams coordinate desk bookings, manage office
            spaces, and stay connected in the hybrid workplace. Know who's in
            the office, book your desk in seconds, and keep your team aligned.
          </p>
          <div
            style={{
              display: 'flex',
              gap: '16px',
              justifyContent: 'center',
              flexWrap: 'wrap'
            }}
          >
            <button
              onClick={() => navigate(routes.signup)}
              style={{
                backgroundColor: '#ffffff',
                color: '#1e3a8a',
                border: 'none',
                padding: '18px 48px',
                fontSize: '1.125rem',
                fontWeight: 700,
                borderRadius: '12px',
                cursor: 'pointer',
                boxShadow: '0 4px 14px rgba(0, 0, 0, 0.25)',
                transition: 'all 0.3s ease',
                fontFamily: 'inherit'
              }}
              onMouseOver={e => {
                e.currentTarget.style.transform = 'translateY(-3px)'
                e.currentTarget.style.boxShadow =
                  '0 8px 25px rgba(0, 0, 0, 0.3)'
              }}
              onMouseOut={e => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow =
                  '0 4px 14px rgba(0, 0, 0, 0.25)'
              }}
            >
              Start Free Today
            </button>
            {isPricingEnabled() && (
              <button
                onClick={() => navigate(routes.pricing)}
                style={{
                  backgroundColor: 'transparent',
                  color: '#ffffff',
                  border: '2px solid rgba(255, 255, 255, 0.8)',
                  padding: '18px 48px',
                  fontSize: '1.125rem',
                  fontWeight: 600,
                  borderRadius: '12px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  fontFamily: 'inherit'
                }}
                onMouseOver={e => {
                  e.currentTarget.style.transform = 'translateY(-3px)'
                  e.currentTarget.style.backgroundColor =
                    'rgba(255, 255, 255, 0.1)'
                }}
                onMouseOut={e => {
                  e.currentTarget.style.transform = 'translateY(0)'
                  e.currentTarget.style.backgroundColor = 'transparent'
                }}
              >
                View Pricing
              </button>
            )}
          </div>

          {/* Trust indicators */}
          <div
            style={{
              marginTop: '64px',
              display: 'flex',
              gap: '32px',
              justifyContent: 'center',
              flexWrap: 'wrap',
              opacity: 0.9
            }}
          >
            <div
              style={{
                color: '#ffffff',
                fontSize: '0.9rem',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}
            >
              <CheckCircleOutlineIcon style={{ fontSize: '18px' }} />
              Free for up to 5 users
            </div>
            <div
              style={{
                color: '#ffffff',
                fontSize: '0.9rem',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}
            >
              <CheckCircleOutlineIcon style={{ fontSize: '18px' }} />
              No credit card required
            </div>
            <div
              style={{
                color: '#ffffff',
                fontSize: '0.9rem',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}
            >
              <CheckCircleOutlineIcon style={{ fontSize: '18px' }} />
              Set up in minutes
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div
          style={{
            textAlign: 'center',
            paddingBottom: '32px',
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: '0.85rem',
            animation: 'bounce 2s infinite'
          }}
        >
          Scroll to learn more
        </div>
      </section>

      {/* ===== FEATURES SECTION ===== */}
      <section
        style={{
          padding: '120px 24px',
          backgroundColor: '#ffffff'
        }}
      >
        <div
          style={{
            maxWidth: '1200px',
            margin: '0 auto'
          }}
        >
          <div style={{ textAlign: 'center', marginBottom: '80px' }}>
            <h2
              style={{
                fontSize: 'clamp(2rem, 3.5vw, 2.75rem)',
                fontWeight: 800,
                color: '#0f172a',
                marginBottom: '20px',
                letterSpacing: '-0.5px'
              }}
            >
              Everything You Need for Hybrid Office Management
            </h2>
            <p
              style={{
                fontSize: '1.2rem',
                color: '#64748b',
                maxWidth: '650px',
                margin: '0 auto',
                lineHeight: 1.7
              }}
            >
              From desk booking to team coordination, Meet for Work provides a
              complete solution for modern hybrid workplaces.
            </p>
          </div>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
              gap: '40px'
            }}
          >
            {/* Feature Card 1 */}
            <div
              style={{
                padding: '40px 32px',
                borderRadius: '20px',
                border: '1px solid #e2e8f0',
                backgroundColor: '#ffffff',
                transition: 'all 0.3s ease',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
              }}
              onMouseOver={e => {
                e.currentTarget.style.transform = 'translateY(-8px)'
                e.currentTarget.style.boxShadow =
                  '0 20px 40px rgba(0, 0, 0, 0.08)'
                e.currentTarget.style.borderColor = '#3b82f6'
              }}
              onMouseOut={e => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow =
                  '0 1px 3px rgba(0, 0, 0, 0.05)'
                e.currentTarget.style.borderColor = '#e2e8f0'
              }}
            >
              <div
                style={{
                  width: '64px',
                  height: '64px',
                  borderRadius: '16px',
                  backgroundColor: '#eff6ff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '24px'
                }}
              >
                <CalendarMonthIcon
                  style={{ fontSize: '32px', color: '#2563eb' }}
                />
              </div>
              <h3
                style={{
                  fontSize: '1.3rem',
                  fontWeight: 700,
                  color: '#0f172a',
                  marginBottom: '12px'
                }}
              >
                Effortless Desk Booking
              </h3>
              <p
                style={{
                  fontSize: '1rem',
                  color: '#64748b',
                  lineHeight: 1.7,
                  margin: 0
                }}
              >
                Book desks for single days or recurring schedules with just a
                few clicks. View real-time availability across all your offices
                and choose the perfect spot for your workday.
              </p>
            </div>

            {/* Feature Card 2 */}
            <div
              style={{
                padding: '40px 32px',
                borderRadius: '20px',
                border: '1px solid #e2e8f0',
                backgroundColor: '#ffffff',
                transition: 'all 0.3s ease',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
              }}
              onMouseOver={e => {
                e.currentTarget.style.transform = 'translateY(-8px)'
                e.currentTarget.style.boxShadow =
                  '0 20px 40px rgba(0, 0, 0, 0.08)'
                e.currentTarget.style.borderColor = '#3b82f6'
              }}
              onMouseOut={e => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow =
                  '0 1px 3px rgba(0, 0, 0, 0.05)'
                e.currentTarget.style.borderColor = '#e2e8f0'
              }}
            >
              <div
                style={{
                  width: '64px',
                  height: '64px',
                  borderRadius: '16px',
                  backgroundColor: '#f0fdf4',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '24px'
                }}
              >
                <GroupsIcon style={{ fontSize: '32px', color: '#16a34a' }} />
              </div>
              <h3
                style={{
                  fontSize: '1.3rem',
                  fontWeight: 700,
                  color: '#0f172a',
                  marginBottom: '12px'
                }}
              >
                Team Coordination
              </h3>
              <p
                style={{
                  fontSize: '1rem',
                  color: '#64748b',
                  lineHeight: 1.7,
                  margin: 0
                }}
              >
                See who's coming to the office at a glance. Coordinate with your
                team, manage multiple office locations, and invite colleagues
                with simple email invitations.
              </p>
            </div>

            {/* Feature Card 3 */}
            <div
              style={{
                padding: '40px 32px',
                borderRadius: '20px',
                border: '1px solid #e2e8f0',
                backgroundColor: '#ffffff',
                transition: 'all 0.3s ease',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
              }}
              onMouseOver={e => {
                e.currentTarget.style.transform = 'translateY(-8px)'
                e.currentTarget.style.boxShadow =
                  '0 20px 40px rgba(0, 0, 0, 0.08)'
                e.currentTarget.style.borderColor = '#3b82f6'
              }}
              onMouseOut={e => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow =
                  '0 1px 3px rgba(0, 0, 0, 0.05)'
                e.currentTarget.style.borderColor = '#e2e8f0'
              }}
            >
              <div
                style={{
                  width: '64px',
                  height: '64px',
                  borderRadius: '16px',
                  backgroundColor: '#fef3c7',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '24px'
                }}
              >
                <NotificationsIcon
                  style={{ fontSize: '32px', color: '#d97706' }}
                />
              </div>
              <h3
                style={{
                  fontSize: '1.3rem',
                  fontWeight: 700,
                  color: '#0f172a',
                  marginBottom: '12px'
                }}
              >
                Office Notifications
              </h3>
              <p
                style={{
                  fontSize: '1rem',
                  color: '#64748b',
                  lineHeight: 1.7,
                  margin: 0
                }}
              >
                Keep everyone informed with date-specific notifications.
                Announce office closures, maintenance schedules, team events, or
                important policy updates directly in the calendar.
              </p>
            </div>

            {/* Feature Card 4 */}
            <div
              style={{
                padding: '40px 32px',
                borderRadius: '20px',
                border: '1px solid #e2e8f0',
                backgroundColor: '#ffffff',
                transition: 'all 0.3s ease',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
              }}
              onMouseOver={e => {
                e.currentTarget.style.transform = 'translateY(-8px)'
                e.currentTarget.style.boxShadow =
                  '0 20px 40px rgba(0, 0, 0, 0.08)'
                e.currentTarget.style.borderColor = '#3b82f6'
              }}
              onMouseOut={e => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow =
                  '0 1px 3px rgba(0, 0, 0, 0.05)'
                e.currentTarget.style.borderColor = '#e2e8f0'
              }}
            >
              <div
                style={{
                  width: '64px',
                  height: '64px',
                  borderRadius: '16px',
                  backgroundColor: '#fae8ff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '24px'
                }}
              >
                <BusinessIcon style={{ fontSize: '32px', color: '#9333ea' }} />
              </div>
              <h3
                style={{
                  fontSize: '1.3rem',
                  fontWeight: 700,
                  color: '#0f172a',
                  marginBottom: '12px'
                }}
              >
                Multi-Office Management
              </h3>
              <p
                style={{
                  fontSize: '1rem',
                  color: '#64748b',
                  lineHeight: 1.7,
                  margin: 0
                }}
              >
                Manage multiple office locations from one account. Each office
                has its own desks, team members, and subscription. Perfect for
                growing companies with distributed teams.
              </p>
            </div>

            {/* Feature Card 5 */}
            <div
              style={{
                padding: '40px 32px',
                borderRadius: '20px',
                border: '1px solid #e2e8f0',
                backgroundColor: '#ffffff',
                transition: 'all 0.3s ease',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
              }}
              onMouseOver={e => {
                e.currentTarget.style.transform = 'translateY(-8px)'
                e.currentTarget.style.boxShadow =
                  '0 20px 40px rgba(0, 0, 0, 0.08)'
                e.currentTarget.style.borderColor = '#3b82f6'
              }}
              onMouseOut={e => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow =
                  '0 1px 3px rgba(0, 0, 0, 0.05)'
                e.currentTarget.style.borderColor = '#e2e8f0'
              }}
            >
              <div
                style={{
                  width: '64px',
                  height: '64px',
                  borderRadius: '16px',
                  backgroundColor: '#ecfeff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '24px'
                }}
              >
                <DashboardIcon style={{ fontSize: '32px', color: '#0891b2' }} />
              </div>
              <h3
                style={{
                  fontSize: '1.3rem',
                  fontWeight: 700,
                  color: '#0f172a',
                  marginBottom: '12px'
                }}
              >
                Visual Calendar Dashboard
              </h3>
              <p
                style={{
                  fontSize: '1rem',
                  color: '#64748b',
                  lineHeight: 1.7,
                  margin: 0
                }}
              >
                A 4-week calendar view shows all bookings at a glance with
                color-coded offices. See who's booked where, plan your week, and
                never miss an office day.
              </p>
            </div>

            {/* Feature Card 6 */}
            <div
              style={{
                padding: '40px 32px',
                borderRadius: '20px',
                border: '1px solid #e2e8f0',
                backgroundColor: '#ffffff',
                transition: 'all 0.3s ease',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
              }}
              onMouseOver={e => {
                e.currentTarget.style.transform = 'translateY(-8px)'
                e.currentTarget.style.boxShadow =
                  '0 20px 40px rgba(0, 0, 0, 0.08)'
                e.currentTarget.style.borderColor = '#3b82f6'
              }}
              onMouseOut={e => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow =
                  '0 1px 3px rgba(0, 0, 0, 0.05)'
                e.currentTarget.style.borderColor = '#e2e8f0'
              }}
            >
              <div
                style={{
                  width: '64px',
                  height: '64px',
                  borderRadius: '16px',
                  backgroundColor: '#fef2f2',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '24px'
                }}
              >
                <TuneIcon style={{ fontSize: '32px', color: '#dc2626' }} />
              </div>
              <h3
                style={{
                  fontSize: '1.3rem',
                  fontWeight: 700,
                  color: '#0f172a',
                  marginBottom: '12px'
                }}
              >
                Flexible Subscriptions
              </h3>
              <p
                style={{
                  fontSize: '1rem',
                  color: '#64748b',
                  lineHeight: 1.7,
                  margin: 0
                }}
              >
                Start free with up to 5 users and scale as you grow. Upgrade or
                downgrade plans anytime with transparent pricing and no
                long-term commitments.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== HOW IT WORKS SECTION ===== */}
      <section
        style={{
          padding: '120px 24px',
          backgroundColor: '#f8fafc'
        }}
      >
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '80px' }}>
            <h2
              style={{
                fontSize: 'clamp(2rem, 3.5vw, 2.75rem)',
                fontWeight: 800,
                color: '#0f172a',
                marginBottom: '20px',
                letterSpacing: '-0.5px'
              }}
            >
              Get Started in Three Simple Steps
            </h2>
            <p
              style={{
                fontSize: '1.2rem',
                color: '#64748b',
                maxWidth: '600px',
                margin: '0 auto',
                lineHeight: 1.7
              }}
            >
              Setting up your hybrid office management takes just minutes. No
              complicated onboarding, no technical knowledge required.
            </p>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '48px'
            }}
          >
            {/* Step 1 */}
            <div
              style={{
                display: 'flex',
                gap: '32px',
                alignItems: 'flex-start',
                flexWrap: 'wrap'
              }}
            >
              <div
                style={{
                  width: '72px',
                  height: '72px',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #3b82f6, #1e40af)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#ffffff',
                  fontSize: '1.75rem',
                  fontWeight: 800,
                  flexShrink: 0,
                  boxShadow: '0 8px 20px rgba(59, 130, 246, 0.3)'
                }}
              >
                1
              </div>
              <div style={{ flex: 1, minWidth: '250px' }}>
                <h3
                  style={{
                    fontSize: '1.4rem',
                    fontWeight: 700,
                    color: '#0f172a',
                    marginBottom: '12px',
                    marginTop: '12px'
                  }}
                >
                  Create Your Office & Desks
                </h3>
                <p
                  style={{
                    fontSize: '1.05rem',
                    color: '#64748b',
                    lineHeight: 1.8,
                    margin: 0
                  }}
                >
                  Sign up for free and create your first office. Add desks with
                  names and labels to represent your physical workspace. The
                  office is automatically created when you add your first desk —
                  no complex setup needed.
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div
              style={{
                display: 'flex',
                gap: '32px',
                alignItems: 'flex-start',
                flexWrap: 'wrap'
              }}
            >
              <div
                style={{
                  width: '72px',
                  height: '72px',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #3b82f6, #1e40af)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#ffffff',
                  fontSize: '1.75rem',
                  fontWeight: 800,
                  flexShrink: 0,
                  boxShadow: '0 8px 20px rgba(59, 130, 246, 0.3)'
                }}
              >
                2
              </div>
              <div style={{ flex: 1, minWidth: '250px' }}>
                <h3
                  style={{
                    fontSize: '1.4rem',
                    fontWeight: 700,
                    color: '#0f172a',
                    marginBottom: '12px',
                    marginTop: '12px'
                  }}
                >
                  Invite Your Team
                </h3>
                <p
                  style={{
                    fontSize: '1.05rem',
                    color: '#64748b',
                    lineHeight: 1.8,
                    margin: 0
                  }}
                >
                  Send email invitations to your colleagues. When they sign up
                  with their invited email, they'll automatically have access to
                  book desks in your office. It's that simple — no admin
                  overhead.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div
              style={{
                display: 'flex',
                gap: '32px',
                alignItems: 'flex-start',
                flexWrap: 'wrap'
              }}
            >
              <div
                style={{
                  width: '72px',
                  height: '72px',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #3b82f6, #1e40af)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#ffffff',
                  fontSize: '1.75rem',
                  fontWeight: 800,
                  flexShrink: 0,
                  boxShadow: '0 8px 20px rgba(59, 130, 246, 0.3)'
                }}
              >
                3
              </div>
              <div style={{ flex: 1, minWidth: '250px' }}>
                <h3
                  style={{
                    fontSize: '1.4rem',
                    fontWeight: 700,
                    color: '#0f172a',
                    marginBottom: '12px',
                    marginTop: '12px'
                  }}
                >
                  Book & Coordinate
                </h3>
                <p
                  style={{
                    fontSize: '1.05rem',
                    color: '#64748b',
                    lineHeight: 1.8,
                    margin: 0
                  }}
                >
                  Your team can now book desks, see who's in the office each
                  day, and plan their hybrid schedules. The visual calendar
                  makes it easy to coordinate and ensures everyone knows where
                  to find each other.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== WHY CHOOSE US / TRUST SECTION ===== */}
      <section
        style={{
          padding: '120px 24px',
          backgroundColor: '#ffffff'
        }}
      >
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '80px' }}>
            <h2
              style={{
                fontSize: 'clamp(2rem, 3.5vw, 2.75rem)',
                fontWeight: 800,
                color: '#0f172a',
                marginBottom: '20px',
                letterSpacing: '-0.5px'
              }}
            >
              Built for Modern Hybrid Teams
            </h2>
            <p
              style={{
                fontSize: '1.2rem',
                color: '#64748b',
                maxWidth: '650px',
                margin: '0 auto',
                lineHeight: 1.7
              }}
            >
              Whether you're a small startup or a growing company, Meet for Work
              adapts to your team's needs.
            </p>
          </div>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '48px'
            }}
          >
            <div style={{ textAlign: 'center' }}>
              <SecurityIcon
                style={{
                  fontSize: '48px',
                  color: '#2563eb',
                  marginBottom: '16px'
                }}
              />
              <h3
                style={{
                  fontSize: '1.2rem',
                  fontWeight: 700,
                  color: '#0f172a',
                  marginBottom: '8px'
                }}
              >
                Secure & Private
              </h3>
              <p
                style={{
                  fontSize: '0.95rem',
                  color: '#64748b',
                  lineHeight: 1.7,
                  margin: 0
                }}
              >
                Built on enterprise-grade infrastructure with role-based access
                control. Only your team sees your office data.
              </p>
            </div>

            <div style={{ textAlign: 'center' }}>
              <GroupsIcon
                style={{
                  fontSize: '48px',
                  color: '#2563eb',
                  marginBottom: '16px'
                }}
              />
              <h3
                style={{
                  fontSize: '1.2rem',
                  fontWeight: 700,
                  color: '#0f172a',
                  marginBottom: '8px'
                }}
              >
                Scales With You
              </h3>
              <p
                style={{
                  fontSize: '0.95rem',
                  color: '#64748b',
                  lineHeight: 1.7,
                  margin: 0
                }}
              >
                Start free with 5 users and grow to 200+. Upgrade or downgrade
                anytime — no contracts, no lock-in.
              </p>
            </div>

            <div style={{ textAlign: 'center' }}>
              <CalendarMonthIcon
                style={{
                  fontSize: '48px',
                  color: '#2563eb',
                  marginBottom: '16px'
                }}
              />
              <h3
                style={{
                  fontSize: '1.2rem',
                  fontWeight: 700,
                  color: '#0f172a',
                  marginBottom: '8px'
                }}
              >
                Works on All Devices
              </h3>
              <p
                style={{
                  fontSize: '0.95rem',
                  color: '#64748b',
                  lineHeight: 1.7,
                  margin: 0
                }}
              >
                Responsive design works beautifully on desktop, tablet, and
                mobile. Book a desk from anywhere, anytime.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== CTA SECTION ===== */}
      <section
        style={{
          padding: '100px 24px',
          background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)',
          textAlign: 'center'
        }}
      >
        <div style={{ maxWidth: '700px', margin: '0 auto' }}>
          <h2
            style={{
              fontSize: 'clamp(2rem, 3.5vw, 2.75rem)',
              fontWeight: 800,
              color: '#ffffff',
              marginBottom: '20px',
              lineHeight: 1.2
            }}
          >
            Ready to Simplify Your Hybrid Office?
          </h2>
          <p
            style={{
              fontSize: '1.2rem',
              color: 'rgba(255, 255, 255, 0.9)',
              marginBottom: '40px',
              lineHeight: 1.7
            }}
          >
            Join teams already using Meet for Work to coordinate their desk
            bookings and streamline hybrid collaboration. Get started in under
            two minutes.
          </p>
          <button
            onClick={() => navigate(routes.signup)}
            style={{
              backgroundColor: '#ffffff',
              color: '#1e3a8a',
              border: 'none',
              padding: '18px 56px',
              fontSize: '1.2rem',
              fontWeight: 700,
              borderRadius: '12px',
              cursor: 'pointer',
              boxShadow: '0 4px 14px rgba(0, 0, 0, 0.25)',
              transition: 'all 0.3s ease',
              fontFamily: 'inherit'
            }}
            onMouseOver={e => {
              e.currentTarget.style.transform = 'translateY(-3px)'
              e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.3)'
            }}
            onMouseOut={e => {
              e.currentTarget.style.transform = 'translateY(0)'
              e.currentTarget.style.boxShadow = '0 4px 14px rgba(0, 0, 0, 0.25)'
            }}
          >
            Get Started Free
          </button>
        </div>
      </section>

      {/* ===== FOOTER ===== */}
      <footer
        style={{
          padding: '48px 24px 32px',
          backgroundColor: '#0f172a',
          color: '#ffffff'
        }}
      >
        <div
          style={{
            maxWidth: '1200px',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '24px'
          }}
        >
          <div
            style={{
              fontSize: '1.3rem',
              fontWeight: 700,
              letterSpacing: '-0.5px'
            }}
          >
            Meet for Work
          </div>
          <p
            style={{
              margin: 0,
              fontSize: '0.95rem',
              color: 'rgba(255, 255, 255, 0.7)',
              textAlign: 'center'
            }}
          >
            A modern desk booking solution for hybrid teams. Coordinate your
            office, one desk at a time.
          </p>
          <div
            style={{
              display: 'flex',
              gap: '24px',
              justifyContent: 'center',
              flexWrap: 'wrap',
              fontSize: '0.9rem'
            }}
          >
            <button
              onClick={() => navigate(routes.privacyPolicy)}
              style={{
                background: 'none',
                border: 'none',
                color: 'rgba(255, 255, 255, 0.8)',
                cursor: 'pointer',
                textDecoration: 'none',
                fontSize: 'inherit',
                fontFamily: 'inherit',
                padding: 0,
                transition: 'color 0.2s ease'
              }}
              onMouseOver={e => {
                e.currentTarget.style.color = '#ffffff'
              }}
              onMouseOut={e => {
                e.currentTarget.style.color = 'rgba(255, 255, 255, 0.8)'
              }}
            >
              Privacy Policy
            </button>
            <button
              onClick={() => navigate(routes.termsOfService)}
              style={{
                background: 'none',
                border: 'none',
                color: 'rgba(255, 255, 255, 0.8)',
                cursor: 'pointer',
                textDecoration: 'none',
                fontSize: 'inherit',
                fontFamily: 'inherit',
                padding: 0,
                transition: 'color 0.2s ease'
              }}
              onMouseOver={e => {
                e.currentTarget.style.color = '#ffffff'
              }}
              onMouseOut={e => {
                e.currentTarget.style.color = 'rgba(255, 255, 255, 0.8)'
              }}
            >
              Terms of Service
            </button>
            <button
              onClick={() => navigate(routes.help)}
              style={{
                background: 'none',
                border: 'none',
                color: 'rgba(255, 255, 255, 0.8)',
                cursor: 'pointer',
                textDecoration: 'none',
                fontSize: 'inherit',
                fontFamily: 'inherit',
                padding: 0,
                transition: 'color 0.2s ease'
              }}
              onMouseOver={e => {
                e.currentTarget.style.color = '#ffffff'
              }}
              onMouseOut={e => {
                e.currentTarget.style.color = 'rgba(255, 255, 255, 0.8)'
              }}
            >
              Help
            </button>
            {isPricingEnabled() && (
              <button
                onClick={() => navigate(routes.pricing)}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'rgba(255, 255, 255, 0.8)',
                  cursor: 'pointer',
                  textDecoration: 'none',
                  fontSize: 'inherit',
                  fontFamily: 'inherit',
                  padding: 0,
                  transition: 'color 0.2s ease'
                }}
                onMouseOver={e => {
                  e.currentTarget.style.color = '#ffffff'
                }}
                onMouseOut={e => {
                  e.currentTarget.style.color = 'rgba(255, 255, 255, 0.8)'
                }}
              >
                Pricing
              </button>
            )}
          </div>
          <div
            style={{
              marginTop: '16px',
              paddingTop: '24px',
              borderTop: '1px solid rgba(255, 255, 255, 0.1)',
              width: '100%',
              textAlign: 'center',
              fontSize: '0.85rem',
              color: 'rgba(255, 255, 255, 0.5)'
            }}
          >
            &copy; {new Date().getFullYear()} Meet for Work. All rights
            reserved.
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Landing
